import React from 'react'
import Icon from '../icon'

interface BadgeProps {
  icon?: string
  text?: string
  variant?: 'primary' | 'secondary'
  brand?: string
  isCrown?: boolean
  size?: number
}

const Badge: React.FC<BadgeProps> = ({
  icon,
  text,
  variant = 'primary',
  brand,
  isCrown = false,
  size,
}) => {
  const defaultSize = isCrown ? 30 : 24

  return isCrown ? (
    <div className={`Badge-icon-wrapper--${variant}`}>
      {icon && <Icon glyph={icon} brand={brand} ariaLabel={icon} size={size || defaultSize} />}
      {text && <span>{text}</span>}
    </div>
  ) : (
    <div className={`Badge-top-cta-wrapper`}>
      <div className='Badge-top-cta-wrapper-inner'>
        {icon && (
          <div className='Badge-icon-wrapper'>
            <Icon glyph={icon} brand={brand} ariaLabel={icon} size={size || defaultSize} />
          </div>
        )}
        {text && <span>{text}</span>}
      </div>
    </div>
  )
}

export default Badge
